import { jsx as i, jsxs as r } from "react/jsx-runtime";
import { useTranslation as B, FieldLabel as L, centsToUnits as V } from "@systemeio/ui";
import { useState as w, useRef as F } from "react";
import { CurrencyBadge as G } from "../../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as O } from "../../../../../utils/get-amount-with-currency-symbol.mjs";
import { getPhysicalProductPricePlan as W } from "../../utils/get-physical-product-price-plan.mjs";
import { useLocaleContext as _ } from "../../../../../providers/use-locale-provider.mjs";
import { useOfferStore as q, usePhysicalProductStore as U } from "../../../../../store/index.mjs";
import { Options as z } from "./options.mjs";
import { QuantityPicker as E } from "./quantity-picker.mjs";
import { Slider as H } from "./slider/index.mjs";
import { useWatch as J } from "@systemeio/util";
const ce = ({ product: c }) => {
  const { currency: y, productVariants: P, images: b = [], name: S, stock: N, limitStock: k } = c, [l, m] = w([]), { setPricePlan: d, setFinalAmount: f } = q(), { locale: v } = _(), { quantity: a, setQuantity: u, productVariant: o, setProductVariant: p } = U(), { t: I } = B(), n = F(null), D = (t) => {
    var s;
    (s = n == null ? void 0 : n.current) == null || s.slickGoTo(t);
  }, g = (t, s) => {
    const e = W(t, s);
    e && (d(e), f(e.amount));
  }, C = (t) => {
    var s;
    if (p(t), t.image) {
      const e = [t.image, ...l.slice(1)];
      m(e), (s = n.current) == null || s.slickGoTo(0);
    }
    g(c, t);
  };
  J(c, (t) => {
    if (!t)
      d(void 0), f(void 0);
    else {
      const s = [...b], e = o ?? P[0];
      e && p(e), e != null && e.image && s.unshift(e.image), m(s), e && g(t, e);
    }
  });
  const h = (o == null ? void 0 : o.stock) ?? N ?? 0, Q = () => u(a + 1), T = () => u(a - 1), x = h > 0 && k ? h : void 0, A = !!x && a >= x, j = a <= 1;
  return /* @__PURE__ */ i("div", { className: "flex flex-col gap-3 sm:gap-5", children: /* @__PURE__ */ r("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ i(L, { label: I("public_pages_purchase.product") }),
    /* @__PURE__ */ r(
      "div",
      {
        className: "border-text-secondary/30 flex flex-col gap-3.5 rounded-lg border px-3.5 py-5",
        children: [
          o && /* @__PURE__ */ i(
            z,
            {
              product: c,
              activeVariant: o,
              changeActiveVariant: C
            }
          ),
          /* @__PURE__ */ i(
            E,
            {
              quantity: a,
              onIncrease: Q,
              onDecrease: T,
              disabledIncreaseButton: A,
              disabledDecreaseButton: j
            }
          ),
          /* @__PURE__ */ i(H, { goToSlide: D, ref: n, images: l }),
          /* @__PURE__ */ r("div", { className: "items flex justify-between", children: [
            /* @__PURE__ */ i("h2", { className: "text-[14px] font-normal", children: S }),
            /* @__PURE__ */ r("div", { className: "flex items-center gap-2.5", children: [
              /* @__PURE__ */ i(G, { currency: y }),
              /* @__PURE__ */ i("span", { className: "text-[14px] font-semibold", children: O(
                V((o == null ? void 0 : o.price) ?? c.price),
                c.currency,
                v
              ) })
            ] })
          ] })
        ]
      }
    )
  ] }) });
};
export {
  ce as ProductCard
};
